import { useState, SyntheticEvent, useEffect } from 'react';
import './AdminDashboard.scss';
import { changeAdComponent, visibility } from '../../redux/slices/rightSideAd';
import { useAppDispatch, useAppSelector } from '../../redux/app/hooks';
import AdminTeachers from "../AdminTeachers/AdminTeachers";
import AdminAnnouncement from '../AdminAnnouncement/AdminAnnouncement';
import AdminClassroom from '../AdminClassroom/AdminClassroom';
import { Tab, Tabs, styled } from "@mui/material";
import AdminStudentsClassroom from '../AdminStudents/AdminStudentsClassroom';
import MobileScreenHeader from '../../components/MobileScreenHeader/MobileScreenHeader';
import { getScreenDimensions } from '../../utils/helper';
import { setHideScrollToTopButton } from '../../redux/slices/authSlice';
import { getPtaContainer } from '../../components/AdminRightSideAd/AdminRightSideAd';
import { useNavigate } from 'react-router-dom';

// Custom styled Tab component
const CustomTab = styled(Tab)(({ theme }) => ({
  minWidth: 'fit-content',
  fontFamily: 'var(--font-inter)',
  fontWeight: 600,
  fontSize: 14,
  lineHeight: '16.94px',
  textTransform: 'capitalize',
  padding: '0 var(--padding-3xs)',
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '&.Mui-selected': {
    color: 'black',
  },
  '&:not(.Mui-selected)': {
    color: 'black',
  },
}));

const AdminDashboard = () => {
  const dispatch = useAppDispatch();
  dispatch(visibility({ isVisible: true }));

  const tab = localStorage?.getItem('adminDashboardTabIndex');
  const [activeTab, setActiveTab] = useState(tab ? parseInt(tab) : 0);
  const role = useAppSelector((state) => state.auth.role);
  const profile = useAppSelector((state) => state.auth.adminProfile);
  const profileImage = useAppSelector((state) => state?.auth?.adminProfileImage);
  const hideScrollToTopButton = useAppSelector((state) => state?.auth?.hideScrollToTopButton);
  const StudentName = profile?.getCurrentUser?.nodes?.[0]?.uFullName;
  const { isMobileScreen } = getScreenDimensions();
  const [isSearchClick, setisSearchClick] = useState<boolean>(false);
  const [isFullView, setisFullView] = useState<boolean>(false);
  const navigate = useNavigate();

  const components = [
    <AdminTeachers key="admin-teachers" isFullView={isFullView} setisFullView={setisFullView} isSearchClick={isSearchClick} setisSearchClick={setisSearchClick} />,
    <AdminStudentsClassroom key="admin-students" isFullView={isFullView} setisFullView={setisFullView} isSearchClick={isSearchClick} setisSearchClick={setisSearchClick} />,
    <AdminClassroom key="admin-classroom"isFullView={isFullView} setisFullView={setisFullView} isSearchClick={isSearchClick} setisSearchClick={setisSearchClick} />,
    <AdminAnnouncement key="admin-announcement" isFullView={isFullView} isSearchClick={isSearchClick} setisSearchClick={setisSearchClick} />
  ];  

  const handleChangeTab = (_e: SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    localStorage.setItem('adminDashboardTabIndex', String(newValue));
    dispatch(changeAdComponent({ adComponent: newValue }));
  };

  useEffect(() => {
    setActiveTab(tab ? parseInt(tab) : 0);
  }, [tab]);

  const handleSearchClick = () => {
    setisSearchClick(true);
  };


  useEffect(() => {
    dispatch(setHideScrollToTopButton({ hideScrollToTopButton: activeTab === 1 ? true : !isFullView }));
  }, [isFullView, isSearchClick])

  useEffect(() => {
    dispatch(setHideScrollToTopButton({ hideScrollToTopButton: !isSearchClick }));
  }, [isSearchClick])

  return (
    <div className='adminDashboardMainContainer'>
      {!isFullView && isMobileScreen && !isSearchClick && 
      <div className='adminMobileHeader'>
        {/* <MobileHeader /> */}
        <MobileScreenHeader
            profileImage={profileImage}
            role={role}
            studentName={StudentName}
            profile={profile}
            handleSearchClick={handleSearchClick} 
        />
        <div className="mobileDashboardTitleTextStyle">Dashboard</div>
      </div>}
      {!isSearchClick && !isFullView && hideScrollToTopButton && getPtaContainer(navigate)}
      {(!isFullView || !isMobileScreen) && !isSearchClick && <Tabs
        className='adminDashboardMainContainerHeader'
        value={activeTab}
        onChange={handleChangeTab}
        variant="fullWidth"
        TabIndicatorProps={{
          style: {
            backgroundColor: 'transparent',
            height: '3px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          },
          children: <span className="MuiTabs-indicatorSpan" />
        }}
      >
        <CustomTab className='adminDashboardMainContainerHeaderItems' label="Teachers" />
        <CustomTab className='adminDashboardMainContainerHeaderItems' label="Students" />
        <CustomTab className='adminDashboardMainContainerHeaderItems' label="Classroom" />
        <CustomTab className='adminDashboardMainContainerHeaderItems' label="Announcement" />
      </Tabs>}
      <div className="adminDashboardMainContainerComponents" style={{ height: ((isFullView || isSearchClick) && isMobileScreen) ? '100%' : '' }}>
        {components?.[activeTab] ? components?.[activeTab] : components?.[0]}
      </div>
    </div>
  );
};

export default AdminDashboard;
